import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { FormField } from '../../../../../../../global/form/form-field/form-field';
import { action } from 'mobx';
import React from 'react';
import CustomFieldVM from '../custom-field.viewmodel';
import OECheckbox from '../../../../../../../global/oe-checkbox/oe-checkbox';
import { ICustomFieldsDTO } from '../../../../../../../../api/custom-fields.dao';


type Props = {
    vm: CustomFieldVM;
    field: ICustomFieldsDTO;
    labelFieldError: string | null;
};
export const CustomFieldAttendanceMethod = observer((props: Props) => {
    const { vm, field, labelFieldError } = props;

    const checkAnswerOption = action((key: string): void => {
        field.optionsList.push(key);
    });

    const uncheckAnswerOption = action((key: string): void => {
        const idx = field.optionsList.indexOf(key);
        if (idx !== -1) {
            field.optionsList.splice(idx, 1);
        }
    });

    const isOptionChecked = (key: string): boolean => field.optionsList.includes(key);

    return (
        <>
            <FormField
                className='m-bottom-20px'
                label={<FormattedMessage id='oe.label.fieldId' description='Label text' defaultMessage='Field ID' />}
            >
                <div className='flex'>
                    <input
                        className='oe-form-field__control'
                        value={vm.triageQuestionField.defaultFieldTitle}
                        readOnly
                        disabled
                        onChange={undefined}
                        type='text'
                    />
                </div>
            </FormField>
            <FormField
                className='m-bottom-20px'
                label={<FormattedMessage id='oe.label.fieldLabel' description='Label text' defaultMessage='Field Label' />}
            >
                <input
                    id='customField-label'
                    className='oe-form-field__control'
                    value={vm.triageQuestionField.label}
                    onBlur={() => vm.setTouchFieldStatus('isLabelChanged')}
                    onChange={action(e => {
                        vm.setTouchFieldStatus('isLabelChanged');
                        vm.triageQuestionField.label = e.target.value;
                    })}
                    type='text'
                />
                {labelFieldError &&
                    <span className='oe-form-field__error'>
                        {<FormattedMessage
                            id='oe.label.fieldLabelError'
                            description='Label text'
                            defaultMessage='Field Label {suffix}'
                            values={{
                                suffix: labelFieldError
                            }}
                        />}
                    </span>
                }
            </FormField>
            <FormField
                className='custom-field__attendance-method-options m-bottom-20px'
                label={<FormattedMessage id='oe.triageQuestion.answerOptions' description='Label text' defaultMessage='Answer Options' />}
            >{Object.entries(vm.attendanceMethodOptions)
                .map(([key, value]) => {
                    return (
                        <OECheckbox
                            key={key}
                            label={<FormattedMessage id={`oe.attendanceMethodOption.${key}`} defaultMessage={value} description='Label text' />}
                            checked={isOptionChecked(key)}
                            onChange={() => isOptionChecked(key) ? uncheckAnswerOption(key) : checkAnswerOption(key)}
                            classNames='oe-form-field__checkbox'
                        />
                    );
            })}
            </FormField>
        </>
    );
});
